module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row max-height-vertical box-overflow"
  }, [_c('div', {
    ref: "scrollHookOne",
    staticClass: "row scroll-outer scroll-padding-bottom"
  }, [_c('div', {
    staticClass: "span-14-lg offset-1-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs "
  }, [_c('p', {
    staticClass: "large",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row span-16-lg span-16-md span-16-sm span-16-xs  "
  }, [_c('div', {
    staticClass: "span-9-lg offset-1-lg span-8-md max-height-selector  overflow-hidden"
  }, _vm._l((_vm.content.cards), function(card, index) {
    return _c('progress-selector', {
      key: index,
      ref: index + 1,
      refInFor: true,
      attrs: {
        "index": index,
        "activeindex": _vm.offset_index
      },
      on: {
        "clicked": function($event) {
          _vm.selectorCallback(card, index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(card.title) + "\n        ")])
  })), _vm._v(" "), _c('div', {
    ref: "selectorCard",
    staticClass: "span-4-lg offset-1-lg span-6-md offset-1-md span-16-sm span-16-xs bg-white border-blue-hover selector-indicator-card content-translate ",
    class: [_vm.indicatorClass, _vm.indicatorVisibleClass, _vm.contentActiveClass, _vm.hasContentClass],
    style: (_vm.ratio_styles),
    attrs: {
      "container-card": "selector-card"
    },
    on: {
      "click": _vm.toggleIndicator
    }
  }, [_c('div', {
    staticClass: "mobile-only arrow-back-container",
    on: {
      "click": _vm.toggleIndicator
    }
  }, [_c('arrow', {
    attrs: {
      "type": "prev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "overflow-hidden center-flex cover-class crosshair-rollover-trigger",
    class: _vm.hasContentClass
  }, [_c('div', {
    ref: "scrollHookTwo",
    staticClass: "scroll-outer maintain-outer"
  }, [(_vm.card) ? _c('div', {
    staticClass: "card-inner"
  }, [_c(_vm.card.icon, {
    tag: "component",
    staticClass: "big-svg svg-fill-blue"
  }), _vm._v(" "), _c('p', {
    staticClass: "subheader color-blue"
  }, [_vm._v(_vm._s(_vm.card.title))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.markedCard.paragraph)
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('crosshair-background')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "utility bump-up-24 bump-down-12-mobile"
  }, [_c('strong', [_vm._v("Click")]), _vm._v(" through each arrow to learn more before proceeding to the "), _c('strong', [_vm._v("'Next'")]), _vm._v(" button.\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ee86c26"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/templates/pages/selector_page.vue
// module id = 655
// module chunks = 1